export const COMMUNITY_CUSTOM_EMOJI_LIMITS = {
  maxBytes: 50 * 1024,
} as const

export const COMMUNITY_CUSTOM_EMOJI_CANONICAL_PX = 48

const CUSTOM_EMOJI_MIME_TYPES = new Set(['image/png', 'image/jpeg', 'image/gif'])
const CUSTOM_EMOJI_EXTENSIONS = new Set(['png', 'jpg', 'jpeg', 'gif'])

export const COMMUNITY_CUSTOM_EMOJI_ACCEPT = [
  'image/png',
  'image/jpeg',
  'image/gif',
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
].join(',')

function getFileExtension(filename: string): string {
  const name = String(filename || '').trim()
  if (!name) return ''
  const parts = name.split('.')
  if (parts.length < 2) return ''
  return String(parts.pop() || '')
    .trim()
    .toLowerCase()
}

export function isCommunityCustomEmojiFile(file: File): boolean {
  const mime = String(file?.type || '').trim().toLowerCase()
  if (mime) return CUSTOM_EMOJI_MIME_TYPES.has(mime)
  const ext = getFileExtension(String(file?.name || ''))
  return CUSTOM_EMOJI_EXTENSIONS.has(ext)
}

export function validateCommunityCustomEmojiFile(
  file: File,
): { ok: true } | { ok: false; reason: string } {
  if (!file || typeof file.size !== 'number' || file.size <= 0) {
    return { ok: false, reason: 'Arquivo inválido.' }
  }

  if (!isCommunityCustomEmojiFile(file)) {
    return { ok: false, reason: 'Tipo de arquivo não suportado (png/jpg/gif).' }
  }

  if (file.size > COMMUNITY_CUSTOM_EMOJI_LIMITS.maxBytes) {
    return { ok: false, reason: 'Limite excedido (50 KB por emoji).' }
  }

  return { ok: true }
}
